import api from './api';

const TOKEN_KEY = 'flare_token';
const USER_KEY = 'flare_user';
const REMEMBER_EMAIL_KEY = 'flare_remember_email';

const getStore = (remember) => (remember ? window.localStorage : window.sessionStorage);

const migrateAnyExistingSessionToLocal = () => {
  const sTok = window.sessionStorage.getItem(TOKEN_KEY);
  const sUsr = window.sessionStorage.getItem(USER_KEY);
  const lTok = window.localStorage.getItem(TOKEN_KEY);
  if (sTok && !lTok) {
    window.localStorage.setItem(TOKEN_KEY, sTok);
    window.localStorage.setItem(USER_KEY, sUsr || '');
  }
  window.sessionStorage.removeItem(TOKEN_KEY);
  window.sessionStorage.removeItem(USER_KEY);
};

const clearAllAuth = () => {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USER_KEY);
  window.sessionStorage.removeItem(TOKEN_KEY);
  window.sessionStorage.removeItem(USER_KEY);
};

const readAnyStored = (key) =>
  window.localStorage.getItem(key) ?? window.sessionStorage.getItem(key) ?? null;

migrateAnyExistingSessionToLocal();

export const authApi = {
  login: async (email, password, remember = true) => {
    const resp = (await api.post('/login', { email, password })) || {};
    const data = resp.data || {};
    if (data.token) {
      clearAllAuth();
      const store = getStore(remember);
      store.setItem(TOKEN_KEY, data.token);
      store.setItem(USER_KEY, JSON.stringify(data.user));

      if (remember && email) {
        window.localStorage.setItem(REMEMBER_EMAIL_KEY, email);
      } else {
        window.localStorage.removeItem(REMEMBER_EMAIL_KEY);
      }
    }
    return data;
  },

  logout: async () => {
    try {
      await api.post('/logout');
    } catch (e) {
    } finally {
      clearAllAuth();
    }
  },

  me: async () => {
    const resp = (await api.get('/user')) || {};
    const data = resp.data || {};
    if (data.user) {
      const tok = readAnyStored(TOKEN_KEY);
      const target = window.localStorage.getItem(TOKEN_KEY) === tok ? window.localStorage : window.sessionStorage;
      target.setItem(USER_KEY, JSON.stringify(data.user));
    }
    return data;
  },

  getStoredUser: () => {
    const raw = readAnyStored(USER_KEY);
    try {
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },

  getStoredToken: () => readAnyStored(TOKEN_KEY),

  isAuthenticated: () => !!readAnyStored(TOKEN_KEY),

  getRememberedEmail: () => window.localStorage.getItem(REMEMBER_EMAIL_KEY) || '',
};
